export const accountMenu = {
  roles: {
    collaborator: "Współpracownik",
    hostMode: "Tryb gospodarza",
  },
  header: {
    collaboratorAccess: "Dostęp współpracownika",
  },
  panel: {
    label: "Widok panelu",
    apartment: "Apartament",
    hotel: "Hotel",
  },
  groups: {
    navigate: "Nawigacja",
    manage: "Zarządzanie",
  },
  items: {
    home: "Start",
    bookings: "Rezerwacje",
    myAccount: "Moje konto",
    myAccommodations: "Moje obiekty",
    aiReception: "Recepcja AI",
    aiReceptionist: "Recepcjonista AI",
    directBookings: "Rezerwacje bezpośrednie",
    website: "Strona internetowa",
    logout: "Wyloguj się",
  },
  badges: {
    ai: "AI",
    new: "NOWOŚĆ",
  },
  actions: {
    close: "Zamknij",
  },
};
